import React, {useState} from 'react';
import {components, GroupBase, OptionProps} from 'react-select';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import QuestionAnswer, {AnswerTypes} from '../question/QuestionAnswer';
import {IOptions, MultiQuestionSelectProps} from './MultiselectQuestionElement';

function MultiSelectOption(props: OptionProps<IOptions, true, GroupBase<IOptions>>): JSX.Element {
    const {isSelected, label, selectProps, data, selectOption} = props;
    const depth = data.depth || 0;
    const numberOfChildren = data.numberOfChildren || 0;

    const answered =
        'selectProps' in selectProps &&
        'answered' in (selectProps.selectProps as MultiQuestionSelectProps) &&
        (selectProps.selectProps as MultiQuestionSelectProps).answered;

    const correctColor =
        ('selectProps' in selectProps &&
            'correctColor' in (selectProps.selectProps as MultiQuestionSelectProps) &&
            (selectProps.selectProps as MultiQuestionSelectProps).correctColor) ||
        undefined;

    const incorrectColor =
        ('selectProps' in selectProps &&
            'incorrectColor' in (selectProps.selectProps as MultiQuestionSelectProps) &&
            (selectProps.selectProps as MultiQuestionSelectProps).incorrectColor) ||
        undefined;

    const debatableColor =
        ('selectProps' in selectProps &&
            'debatableColor' in (selectProps.selectProps as MultiQuestionSelectProps) &&
            (selectProps.selectProps as MultiQuestionSelectProps).debatableColor) ||
        undefined;

    const device =
        ('selectProps' in selectProps &&
            'device' in (selectProps.selectProps as MultiQuestionSelectProps) &&
            (selectProps.selectProps as MultiQuestionSelectProps).device) ||
        undefined;

    const onCommentOpen =
        ('selectProps' in selectProps &&
            'onCommentOpen' in (selectProps.selectProps as MultiQuestionSelectProps) &&
            (selectProps.selectProps as MultiQuestionSelectProps).onCommentOpen) ||
        undefined;

    const isMobile = device === DeviceType.MOBILE;

    const getAnswerType = (): AnswerTypes => {
        if (answered && isSelected) {
            if (data.type === 'correct') {
                return AnswerTypes.CORRECT;
            }
            if (data.type === 'incorrect') {
                return AnswerTypes.INCORRECT;
            }
            if (data.type === 'debatable') {
                return AnswerTypes.DEBATABLE;
            }
        }
        return isSelected ? AnswerTypes.SELECTED : AnswerTypes.NONE;
    };

    const [showComment, setShowComment] = useState(false);

    const handleClick = (): void => {
        if (numberOfChildren === 0) {
            selectOption(data);
        }
    };

    const leadingIcon = (): undefined | string => {
        if (numberOfChildren > 0) return undefined;
        return isSelected ? 'solar:check-square-bold' : 'solar:stop-linear';
    };

    return (
        <components.Option
            {...props}
            innerProps={{
                // eslint-disable-next-line react/destructuring-assignment
                ...props.innerProps,
                style: {
                    // eslint-disable-next-line react/destructuring-assignment
                    ...props.innerProps.style,
                    marginLeft: `${depth}em`,
                    pointerEvents: numberOfChildren > 0 ? 'none' : 'auto',
                    cursor: numberOfChildren > 0 ? 'default' : 'pointer',
                    width: `calc(100% - ${depth}em)`,
                },
                onClick: handleClick,
            }}
        >
            <div>
                <QuestionAnswer
                    answer={label}
                    answerType={getAnswerType()}
                    correctColor={correctColor}
                    incorrectColor={incorrectColor}
                    debatableColor={debatableColor}
                    leadingIcon={leadingIcon()}
                    comment={answered && isSelected ? data.comment : ''}
                    disabled={answered}
                    onClick={() => undefined}
                    showComment={isMobile ? false : showComment}
                    setShowComment={(show) => {
                        if (!answered || !isSelected || !data.comment) return;
                        if (isMobile) {
                            if (show) onCommentOpen?.(label, data.comment);
                        } else {
                            setShowComment(show);
                        }
                    }}
                    device={device}
                />
            </div>
        </components.Option>
    );
}

export default MultiSelectOption;
